import {PageComponentEnum} from "../Enums/PageComponentEnum";
import {PageInterface} from "./PageInterface";

export interface PageComponentInterface {
	_id: number | string,
	title: string,
	page_id: number,
	type: PageComponentEnum,
	data: any,
	status: boolean,
	sort: number,
	secured: boolean,
	page?: PageInterface,
	show_title: boolean,
	// The level of the heading of the component (1-6), empty: what the component uses by default
	heading_level?: number | null,
}

export class PageComponentClass implements PageComponentInterface {
	_id = -1;
	data = [];
	page_id = -1;
	secured = true;
	sort = -1;
	status = false;
	title = 'Új komponens';
	type = PageComponentEnum.CAROUSEL;
	show_title = false;
	heading_level = null;
}
